import React from 'react'
import "../../css/Footer.css"

const Footer = () => {
    const fecha = new Date();
    return (
        <div className="Footer">
            <div className="container-fluid">
                <div className="row ">
                    <div className="col-12 col-lg-12" id="footer-text">
                        <p id="color-parrafo-footer" align="center" >Derechos Reservados Gerencia de Tecnologías y Sistemas de Información © {fecha.getFullYear()} <br />
                            Escuela Superior Politécnica del Litoral - Guayaquil - Ecuador Campus Gustavo Galindo<br />
                            Correo: gerenciatecnologia@espol.edu.ec</p>
                    </div>
                </div>

            </div>
            {/*<div className="fondo-footer " >
            {/*        <p id="color-parrafo-footer">Lorem Ipsum es simplemente el texto de relleno de las imprentas y archivos de texto.*/}
            {/*            Lorem Ipsum ha sido el texto de relleno estándar de las industrias desde el año 1500,*/}
            {/*            cuando un impresor (N. del T. persona que se dedica a la imprenta) desconocido usó una galería de textos y*/}
            {/*            los mezcló de tal manera que logró hacer un libro de textos especimen.</p>*/}
            {/*</div>*/}
        </div>

    )
}

export default Footer;